import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
    const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 16"
    >
      <g>
        <path
          fill={colorValue}
          fillRule="evenodd"
          d="M10.147 2.147a.5.5 0 01.706 0L12 3.293l1.147-1.146a.498.498 0 01.865.35.5.5 0 01-.159.356L12.707 4l1.146 1.147a.5.5 0 01-.706.706L12 4.707l-1.147 1.146a.498.498 0 01-.865-.35.5.5 0 01.159-.356L11.293 4l-1.146-1.147a.5.5 0 010-.706zM1 3a2 2 0 012-2h.915c.573 0 1.073.39 1.212.947l.737 2.948A1.25 1.25 0 015.401 6.2l-.862.646c-.09.068-.109.166-.084.235a7.523 7.523 0 004.465 4.465c.069.025.167.006.235-.084l.646-.862a1.25 1.25 0 011.304-.463l2.948.737c.556.139.947.639.947 1.213V13a2 2 0 01-2 2h-1.5C5.701 15 1 10.299 1 4.5V3z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};
